import { render, staticRenderFns } from "./recotdingOrderDeal.vue?vue&type=template&id=55d2018f&scoped=true&"
import script from "./recotdingOrderDeal.vue?vue&type=script&lang=ts&"
export * from "./recotdingOrderDeal.vue?vue&type=script&lang=ts&"
import style0 from "./recotdingOrderDeal.vue?vue&type=style&index=0&id=55d2018f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d2018f",
  null
  
)

export default component.exports